import styled from 'styled-components';

const LogoutContainerStyled = styled.div`
  display: flex;
  border: 1px solid #c9cfd7;
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  align-items: center;
  gap: 12px;
  position: relative;

  ${({ loading }) =>
    loading
      ? `
          border: 1px solid #c9cfd7;

          > div > svg > path {
            fill: #c9cfd7;
          }

          > div > span {
            color: #c9cfd7;
          }

          > div > strong {
            color: #c9cfd7;
          }
        `
      : `
          :hover {
            cursor: pointer;
            border: 1px solid #4d008c;

            > div > span {
              color: #4d008c;
            }

            > div > strong {
              color: #4d008c;
            }
          }
        `}
`;

const LogoutIconContainerStyled = styled.div`
  min-width: 32px;
  height: 32px;
`;

const LogoutTextContainerStyled = styled.div`
  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: #494c66;
  }

  strong {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: #0e141d;
  }
`;

const LoadingContainerStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
`;

export {
  LogoutContainerStyled,
  LogoutIconContainerStyled,
  LogoutTextContainerStyled,
  LoadingContainerStyled,
};
